const drawerIconSize = 42;
const drawerItemPadding = 12;
const drawerItemMargin = 12;
const drawerPadding = 28;

const Constants = {
  tvSafeArea: {
    top: 25,
    bottom: 25,
    horizontal: 40,
  },
  drawerIconSize,
  drawerItemPadding,
  drawerItemMargin,
  drawerItemRightPadding: 65,
  drawerPadding,
  drawerWidth: drawerIconSize + drawerItemPadding * 2 + drawerPadding * 2,
  fetchTimeout: 10000,
  apiBaseUrl: 'https://iptvn.idc.md/api/json',
  apiBaseUrlV3: 'https://iptvn.idc.md/api/v3',
  cinemaBaseUrl: __DEV__
    ? 'https://api-dev.portal.idc.md/api/v3'
    : 'https://api.portal.idc.md/api/v3',
  iconBaseUrl: 'https://iptvn.idc.md',
  timeshiftSize: 30,
  startOfDay: '00:00',
  endOfDay: '23:59',
  seekStepVariants: [5, 10, 15, 20],
  fontSizeVariants: [0.7, 0.8, 0.9, 1, 1.1, 1.2],
  criticalErrors: [5, 6, 7, 11, 12, 13],
  supportedMainCarousels: ['banner', 'category', 'movieSelection'],
  favoritesGroup: { id: 0, big_icon: '/img/ico/png/g/0.png', name: undefined },
  publicTermsUrl: 'https://s.idc.md/iptv_pt',
};
export default Constants;
